import {
  IServiceAuditorFinding,
  IServiceAuditorPlainSummary,
  ServiceAuditorFindingCategory,
  ServiceAuditorFindingSeverity,
} from '@commenda/api/agent-platform/service-auditor/types';

export interface IServiceAuditPlainSummaryItem {
  key: keyof IServiceAuditorPlainSummary;
  label: string;
  text: string;
}

export class ServiceAuditFindingHelper {
  static readonly PLAIN_SUMMARY_ORDER: ReadonlyArray<
    keyof IServiceAuditorPlainSummary
  > = ['whatsWrong', 'whyItMatters', 'howToFix'];

  static readonly FINDING_PLAIN_SUMMARY_LABELS: Readonly<
    Record<keyof IServiceAuditorPlainSummary, string>
  > = {
    whatsWrong: "What's wrong",
    whyItMatters: 'Why it matters',
    howToFix: 'How to fix',
  };

  static readonly INTAKE_GAP_PLAIN_SUMMARY_LABELS: Readonly<
    Record<keyof IServiceAuditorPlainSummary, string>
  > = {
    whatsWrong: "What's missing",
    whyItMatters: 'Why it matters',
    howToFix: 'What to ask the customer',
  };

  static readonly FINDING_SEVERITY_ORDER: ReadonlyArray<ServiceAuditorFindingSeverity> =
    [
      ServiceAuditorFindingSeverity.HIGH,
      ServiceAuditorFindingSeverity.MEDIUM,
      ServiceAuditorFindingSeverity.LOW,
    ];

  // The three labelled lines of a plain summary, with intake gap labels for intake gaps; null keeps the expert layout.
  static getPlainSummaryItems(
    finding: Readonly<IServiceAuditorFinding>
  ): IServiceAuditPlainSummaryItem[] | null {
    const { plainSummary } = finding;
    if (!plainSummary) return null;
    const labels =
      finding.category === ServiceAuditorFindingCategory.INTAKE_GAP
        ? ServiceAuditFindingHelper.INTAKE_GAP_PLAIN_SUMMARY_LABELS
        : ServiceAuditFindingHelper.FINDING_PLAIN_SUMMARY_LABELS;
    return ServiceAuditFindingHelper.PLAIN_SUMMARY_ORDER.map((key) => ({
      key,
      label: labels[key],
      text: plainSummary[key],
    }));
  }

  static sortFindings(
    findings: ReadonlyArray<IServiceAuditorFinding>
  ): IServiceAuditorFinding[] {
    return [...findings].sort(
      (left, right) =>
        ServiceAuditFindingHelper.getSeverityPosition(left) -
          ServiceAuditFindingHelper.getSeverityPosition(right) ||
        left.rank - right.rank
    );
  }

  private static getSeverityPosition(
    finding: Readonly<IServiceAuditorFinding>
  ): number {
    return ServiceAuditFindingHelper.FINDING_SEVERITY_ORDER.indexOf(
      finding.severity
    );
  }
}
